/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../api/common';
import '../../bank-accounts/bank_accounts';
import '../../teller/teller';
import '../common/create_bank_transaction_refund';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "BankTransaction": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "updatedAtMs": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "canceledAtMs": {
                    "type": "int64",
                    "id": 14,
                    "rule": "optional"
                  },
                  "completedAtMs": {
                    "type": "int64",
                    "id": 15,
                    "rule": "optional"
                  },
                  "failedAtMs": {
                    "type": "int64",
                    "id": 16,
                    "rule": "optional"
                  },
                  "totalMoney": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "tipMoney": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "taxMoney": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "merchant": {
                    "type": ".squareup.esperanto.api.Merchant",
                    "id": 6,
                    "rule": "optional"
                  },
                  "bankPaymentAuthorization": {
                    "type": ".squareup.esperanto.model.BankPaymentAuthorization",
                    "id": 23,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.esperanto.model.BankTransaction.BankTransactionStatus",
                    "id": 7,
                    "rule": "optional"
                  },
                  "externalBankDetails": {
                    "type": ".squareup.esperanto.model.BankTransferDetails",
                    "id": 8,
                    "rule": "optional"
                  },
                  "gringottsToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "createMoneyTransferResult": {
                    "type": ".squareup.esperanto.model.CreateMoneyTransferResult",
                    "id": 10,
                    "rule": "optional"
                  },
                  "squareBankAccount": {
                    "type": ".squareup.bank_accounts.SquareBankAccount",
                    "id": 11,
                    "rule": "optional"
                  },
                  "failureReason": {
                    "type": ".squareup.teller.FailureReason",
                    "id": 12,
                    "rule": "optional"
                  },
                  "isSyncFailure": {
                    "type": "bool",
                    "id": 17,
                    "rule": "optional"
                  },
                  "internalFailureReason": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "returnReason": {
                    "type": ".squareup.teller.ReturnReason",
                    "id": 19,
                    "rule": "optional"
                  },
                  "failureMessage": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "returnFileToken": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  },
                  "bankTransactionRefund": {
                    "type": ".squareup.esperanto.model.BankTransactionRefund",
                    "id": 13,
                    "rule": "repeated"
                  },
                  "bankTransactionProcessingDetails": {
                    "type": ".squareup.esperanto.model.BankTransactionProcessingDetails",
                    "id": 24,
                    "rule": "optional"
                  },
                  "serverInitiatedFailureReason": {
                    "type": ".squareup.esperanto.model.BankTransaction.ServerInitiatedFailureReason",
                    "id": 25,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "BankTransactionStatus": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CREATED": 5,
                      "PENDING": 1,
                      "CANCELED": 2,
                      "COMPLETED": 3,
                      "FAILED": 4
                    }
                  },
                  "ServerInitiatedFailureReason": {
                    "values": {
                      "DEFAULT_SERVER_INITIATED_FAILURE_REASON_DO_NOT_USE": 0,
                      "RISK_DECLINED": 1
                    }
                  }
                }
              },
              "BankTransferDetails": {
                "fields": {
                  "bankName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transferType": {
                    "type": ".squareup.esperanto.model.BankTransferDetails.TransferType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "accountType": {
                    "type": ".squareup.esperanto.model.BankTransferDetails.AccountType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "fingerprint": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "country": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "statementDescription": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "achDetails": {
                    "type": ".squareup.esperanto.model.ACHDetails",
                    "id": 7,
                    "rule": "optional"
                  },
                  "eftDetails": {
                    "type": ".squareup.esperanto.model.EFTDetails",
                    "id": 8,
                    "rule": "optional"
                  },
                  "verificationMethod": {
                    "type": ".squareup.esperanto.model.BankTransferDetails.VerificationMethod",
                    "id": 9,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "TransferType": {
                    "values": {
                      "TRANSFER_TYPE_DO_NOT_USE": 0,
                      "ACH": 1,
                      "EFT": 3,
                      "TRANSFER_TYPE_UNKNOWN": 2
                    }
                  },
                  "AccountType": {
                    "values": {
                      "ACCOUNT_TYPE_DO_NOT_USE": 0,
                      "INDIVIDUAL": 1,
                      "COMPANY": 2,
                      "ACCOUNT_TYPE_UNKNOWN": 3
                    }
                  },
                  "VerificationMethod": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "INSTITUTION_LOGIN": 1,
                      "MANUAL_ENTRY": 2
                    }
                  }
                }
              },
              "ACHDetails": {
                "fields": {
                  "routingNumber": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "accountNumberSuffix": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "accountType": {
                    "type": ".squareup.esperanto.model.ACHDetails.ACHAccountType",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ACHAccountType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "SAVINGS": 1,
                      "CHECKING": 2,
                      "UNKNOWN": 3
                    }
                  }
                }
              },
              "EFTDetails": {
                "fields": {
                  "routingNumber": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "branch": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "institution": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "accountNumberSuffix": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "accountType": {
                    "type": ".squareup.esperanto.model.EFTDetails.EFTAccountType",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "EFTAccountType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "SAVINGS": 1,
                      "CHECKING": 2,
                      "UNKNOWN": 3
                    }
                  }
                }
              },
              "CreateMoneyTransferResult": {
                "fields": {
                  "moneyTransferToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isSuccess": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "failureReason": {
                    "type": ".squareup.teller.FailureReason",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "BankTransactionRefund": {
                "fields": {
                  "refundUuid": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "refundRequestIdempotenceKey": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "totalMoney": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "createdAtMs": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "updatedAtMs": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "canceledAtMs": {
                    "type": "int64",
                    "id": 10,
                    "rule": "optional"
                  },
                  "completedAtMs": {
                    "type": "int64",
                    "id": 11,
                    "rule": "optional"
                  },
                  "failedAtMs": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  },
                  "refundStatus": {
                    "type": ".squareup.esperanto.model.BankTransactionRefund.BankTransactionRefundStatus",
                    "id": 6,
                    "rule": "optional"
                  },
                  "createMoneyTransferResult": {
                    "type": ".squareup.esperanto.model.CreateMoneyTransferResult",
                    "id": 7,
                    "rule": "optional"
                  },
                  "failureReason": {
                    "type": ".squareup.teller.FailureReason",
                    "id": 8,
                    "rule": "optional"
                  },
                  "isSyncFailure": {
                    "type": "bool",
                    "id": 16,
                    "rule": "optional"
                  },
                  "returnReason": {
                    "type": ".squareup.teller.ReturnReason",
                    "id": 13,
                    "rule": "optional"
                  },
                  "failureMessage": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "returnFileToken": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "refundOrderId": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "appFeeUnitToken": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "refundCreationFailureReason": {
                    "type": ".squareup.esperanto.create_bank_transaction_refund.CreateBankTransactionRefundError",
                    "id": 18,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BankTransactionRefundStatus": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CREATED": 1,
                      "PENDING": 2,
                      "COMPLETED": 3,
                      "FAILED": 4
                    }
                  }
                }
              },
              "BankPaymentAuthorization": {
                "fields": {
                  "authorizationToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "BankTransactionProcessingDetails": {
                "fields": {
                  "speed": {
                    "type": ".squareup.esperanto.model.BankTransactionProcessingDetails.Speed",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Speed": {
                    "values": {
                      "DEFAULT_DO_NOT_USE_PROCESSING_SPEED": 0,
                      "NORMAL": 1,
                      "ACCELERATED": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BankTransaction && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BankTransaction?.nested?.BankTransactionStatus && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BankTransaction?.nested?.ServerInitiatedFailureReason && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BankTransferDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BankTransferDetails?.nested?.TransferType && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BankTransferDetails?.nested?.AccountType && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BankTransferDetails?.nested?.VerificationMethod && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.ACHDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.ACHDetails?.nested?.ACHAccountType && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.EFTDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.EFTDetails?.nested?.EFTAccountType && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.CreateMoneyTransferResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BankTransactionRefund && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BankTransactionRefund?.nested?.BankTransactionRefundStatus && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BankPaymentAuthorization && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BankTransactionProcessingDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BankTransactionProcessingDetails?.nested?.Speed) {
  $root.addJSON(jsonData);
}

/**
 * Bank transaction for an ACH payment.
 *
 * SOURCE BankTransaction @ squareup/esperanto/model/bank.proto at 17:1
 */
export const BankTransaction = $root.lookupType('squareup.esperanto.model.BankTransaction');
fixType(BankTransaction);
Builder.createAndAttachToType(BankTransaction);
/**
 * SOURCE BankTransactionStatus @ squareup/esperanto/model/bank.proto at 48:3
 */
BankTransaction.BankTransactionStatus = $root.lookupEnum('squareup.esperanto.model.BankTransaction.BankTransactionStatus').values;
/**
 * SOURCE ServerInitiatedFailureReason @ squareup/esperanto/model/bank.proto at 117:3
 */
BankTransaction.ServerInitiatedFailureReason = $root.lookupEnum('squareup.esperanto.model.BankTransaction.ServerInitiatedFailureReason').values;
/**
 * Additional bank specific details.
 *
 * SOURCE BankTransferDetails @ squareup/esperanto/model/bank.proto at 128:1
 */
export const BankTransferDetails = $root.lookupType('squareup.esperanto.model.BankTransferDetails');
fixType(BankTransferDetails);
Builder.createAndAttachToType(BankTransferDetails);
/**
 * SOURCE TransferType @ squareup/esperanto/model/bank.proto at 132:3
 */
BankTransferDetails.TransferType = $root.lookupEnum('squareup.esperanto.model.BankTransferDetails.TransferType').values;
/**
 * SOURCE AccountType @ squareup/esperanto/model/bank.proto at 142:3
 */
BankTransferDetails.AccountType = $root.lookupEnum('squareup.esperanto.model.BankTransferDetails.AccountType').values;
/**
 * SOURCE VerificationMethod @ squareup/esperanto/model/bank.proto at 173:3
 */
BankTransferDetails.VerificationMethod = $root.lookupEnum('squareup.esperanto.model.BankTransferDetails.VerificationMethod').values;
/**
 * SOURCE ACHDetails @ squareup/esperanto/model/bank.proto at 187:1
 */
export const ACHDetails = $root.lookupType('squareup.esperanto.model.ACHDetails');
fixType(ACHDetails);
Builder.createAndAttachToType(ACHDetails);
/**
 * SOURCE ACHAccountType @ squareup/esperanto/model/bank.proto at 194:3
 */
ACHDetails.ACHAccountType = $root.lookupEnum('squareup.esperanto.model.ACHDetails.ACHAccountType').values;
/**
 * SOURCE EFTDetails @ squareup/esperanto/model/bank.proto at 208:1
 */
export const EFTDetails = $root.lookupType('squareup.esperanto.model.EFTDetails');
fixType(EFTDetails);
Builder.createAndAttachToType(EFTDetails);
/**
 * SOURCE EFTAccountType @ squareup/esperanto/model/bank.proto at 221:3
 */
EFTDetails.EFTAccountType = $root.lookupEnum('squareup.esperanto.model.EFTDetails.EFTAccountType').values;
/**
 * SOURCE CreateMoneyTransferResult @ squareup/esperanto/model/bank.proto at 239:1
 */
export const CreateMoneyTransferResult = $root.lookupType('squareup.esperanto.model.CreateMoneyTransferResult');
fixType(CreateMoneyTransferResult);
Builder.createAndAttachToType(CreateMoneyTransferResult);
/**
 * Refund for a bank transaction payment.
 *
 * SOURCE BankTransactionRefund @ squareup/esperanto/model/bank.proto at 250:1
 */
export const BankTransactionRefund = $root.lookupType('squareup.esperanto.model.BankTransactionRefund');
fixType(BankTransactionRefund);
Builder.createAndAttachToType(BankTransactionRefund);
/**
 * SOURCE BankTransactionRefundStatus @ squareup/esperanto/model/bank.proto at 275:3
 */
BankTransactionRefund.BankTransactionRefundStatus = $root.lookupEnum('squareup.esperanto.model.BankTransactionRefund.BankTransactionRefundStatus').values;
/**
 * Bank payment authorization details.
 *
 * SOURCE BankPaymentAuthorization @ squareup/esperanto/model/bank.proto at 330:1
 */
export const BankPaymentAuthorization = $root.lookupType('squareup.esperanto.model.BankPaymentAuthorization');
fixType(BankPaymentAuthorization);
Builder.createAndAttachToType(BankPaymentAuthorization);
/**
 * Processing details of a bank transfer.
 *
 * SOURCE BankTransactionProcessingDetails @ squareup/esperanto/model/bank.proto at 338:1
 */
export const BankTransactionProcessingDetails = $root.lookupType('squareup.esperanto.model.BankTransactionProcessingDetails');
fixType(BankTransactionProcessingDetails);
Builder.createAndAttachToType(BankTransactionProcessingDetails);
/**
 * SOURCE Speed @ squareup/esperanto/model/bank.proto at 341:3
 */
BankTransactionProcessingDetails.Speed = $root.lookupEnum('squareup.esperanto.model.BankTransactionProcessingDetails.Speed').values;